
import { Component, Vue, Prop } from 'vue-property-decorator'

const TermsAndConditionsYoutubeProps = Vue.extend({
  props: { },
  components: { }
})

@Component
export default class TermsAndConditionsYoutube extends TermsAndConditionsYoutubeProps {
  data () {
    return {
      isLoading: false,
      today: new Date(),
      lastUpdate: new Date('12-11-2025')
    }
  }
}
